import { render, staticRenderFns } from "./pieChart3.vue?vue&type=template&id=43aa0e1b&scoped=true&"
import script from "./pieChart3.vue?vue&type=script&lang=js&"
export * from "./pieChart3.vue?vue&type=script&lang=js&"
import style0 from "./pieChart3.vue?vue&type=style&index=0&id=43aa0e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa0e1b",
  null
  
)

export default component.exports